export const GifterServiceBaseUrl = 'https://api.qa.gifter.warnerbros.com'; 
export const GifterSharedServiceBaseUrl = ''; 
export const OKTA_CLIENT_ID = "0oa10bl1uf9jefVet0h8";
export const OKTA_ISSUER_URL = "https://ssoqa.wbd.com/oauth2/default";
export const OKTA_REDIRECT_URL = window.location.origin + '/callback';
export const OKTA_URL = "https://sso.wbd.com";
export const IDLE_TIMEOUT = "60";
export const IDLE_WARN_TIMEOUT = "30";